export interface PromotionsListProperties {
  title: string;
  promotionSectionType: string;
  cardsQuantity: number;
}

export type ItemsType = 'bonusItem' | 'bonusActiveItem';

export interface PromotionsListProps {
  title: string;
  promotionSectionType: string;
  cardsQuantity: number;
}

export enum ProductType {
  PROMOTIONS = 'promotions',
  REWARDS = 'rewards',
}

export enum PromotionTabsType {
  PROMOTIONS = 'promotions',
  ACTIVE = 'active',
  BONUS_DETAILS = 'bonus-details',
}

export enum PromotionTabsName {
  PROMOTIONS = 'Promotions',
  ACTIVE = 'Active',
  BONUS_DETAILS = 'Bonus Detail',
}
